import React, { createContext, useContext, useState, useEffect } from 'react';
import { SplashLoader } from '~/components';

const LoaderContext = createContext();

export const useLoader = () => useContext(LoaderContext);

export const LoaderProvider = ({ children }) => {
    const [loadingCount, setLoadingCount] = useState(0);
    const [renderLoader, setRenderLoader] = useState(false);

    const showLoader = () => setLoadingCount(prev => prev + 1);
    const hideLoader = () => setLoadingCount(prev => Math.max(0, prev - 1));

    useEffect(() => {
        let timeout;
        if (loadingCount === 0) {
            // Delay hiding to bridge the gap between sequential loading states
            timeout = setTimeout(() => setRenderLoader(false), 200);
        } else {
            setRenderLoader(true);
        }
        return () => clearTimeout(timeout);
    }, [loadingCount]);

    return (
        <LoaderContext.Provider value={{ showLoader, hideLoader }}>
            {children}
            {renderLoader && (
                <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 99999, backgroundColor: '#ffffff' }}>
                    <SplashLoader />
                </div>
            )}
        </LoaderContext.Provider>
    );
};
